import React from "react";
import { StyleSheet, Text, View, } from "react-native";
export const OnlineStatus = ({ onlineText, offlineText, isOnline, contanerStyle, onlineIndicatorStyle, offlineIndicatorStyle, textStyle, }) => (<View style={[styles.container, contanerStyle]}>
    <View style={[
        styles.indicator,
        isOnline ? onlineIndicatorStyle : offlineIndicatorStyle,
    ]}/>
    <Text style={[styles.text, textStyle]}>
      {isOnline ? onlineText.toUpperCase() : offlineText.toUpperCase()}
    </Text>
  </View>);
const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        paddingVertical: 6,
        paddingHorizontal: 12,
        borderRadius: 16,
        height: 32,
    },
    indicator: {
        width: 8,
        height: 8,
        borderRadius: 4,
        marginRight: 6,
    },
    text: {
        fontSize: 11,
        lineHeight: 14,
    },
});
//# sourceMappingURL=OnlineStatus.js.map